/* eslint-disable import/prefer-default-export */
export enum Environments {
  beta = 'BETA',
  gamma = 'GAMMA',
  prod = 'PROD',
}
